export const setSendingFormKey = Symbol('sendingFormKey') as InjectionKey<Pick<ReturnType<typeof useSendingForm>, 'setSendingForm'>>
export type AppFunnelInject = Pick<ReturnType<typeof useAppFunnel>, 'loading' | 'currentStep' | 'onStepSuccess'>
export const appFunnelKey = Symbol('appFunnelKey') as InjectionKey<AppFunnelInject>
